import cx from 'clsx';

import '#stylesheets/components/Subhead.css';

type SubheadProps = React.OptgroupHTMLAttributes<{
  className?: string;
}>;

export function Subhead({ className, children }: SubheadProps) {
  return <header className={cx('Subhead', className)}>{children}</header>;
}
